import * as AllReducers from './reducers';
import { AppState, TDispatch } from './type';

const ReducerList = Object.keys(AllReducers).map((key: keyof typeof AllReducers) => AllReducers[key]);

export const Reducer = (state: AppState, action: TDispatch): AppState =>
  ReducerList.reduce(
    (aggr, reducer) => ({
      ...aggr,
      [reducer.key]: reducer(state[reducer.key], action),
    }),
    {} as AppState
  );

export const initialState = ReducerList.reduce(
  (aggr, reducer) => ({
    ...aggr,
    [reducer.key]: reducer.initialState,
  }),
  {}
);

export default ReducerList;
